<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="team-profile">
    <h1 class="font-weight-thin display-1 grey--text ml-3 mt-3 hidden-xs-only">
      Team Profile
    </h1>
    <div class="mr-3 ml-3 my-3">
      <v-card flat class="rounded-card">
        <v-container fluid grid-list-md>
          <v-alert
            v-if="error"
            :value="true"
            type="error"
            icon="warning"
            class="mb-4"
          >
            {{ errorMessage }}
          </v-alert>
          <v-form
            id="teamForm"
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent
          >
            <v-layout row wrap>
              <v-flex d-flex xs12 sm6>
                <v-card flat>
                  <v-card-title primary class="title"
                    ><span class="primary--text text-lighten-2"
                      >Update your Team profile</span
                    >
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="name"
                      prepend-icon="people_outline"
                      name="teamname"
                      label="Team name"
                      type="text"
                      :rules="[v => !!v || 'Team name is required']"
                      :error-messages="nameError"
                      required
                      counter
                      maxlength="64"
                      hint="Your team, business, club or organisation name. Used for account
                        management."
                      class="my-1 mr-5"
                    ></v-text-field>
                    <v-textarea
                      v-model="description"
                      prepend-icon="blank"
                      name="description"
                      label="Description"
                      rows="3"
                      class="my-1 mr-5"
                    ></v-textarea>
                    <v-text-field
                      v-model="phone"
                      prepend-icon="blank"
                      name="blank"
                      label="Phone for Team"
                      type="tel"
                      class="my-1 mr-5"
                    ></v-text-field>
                    <v-text-field
                      v-model="url"
                      prepend-icon="blank"
                      name="website"
                      label="Website for Team"
                      type="url"
                      :rules="websiteRules"
                      class="my-1 mr-5"
                    ></v-text-field>
                    <v-text-field
                      v-model="logo"
                      prepend-icon="blank"
                      name="logo"
                      label="Link to Team logo"
                      type="url"
                      :rules="websiteRules"
                      class="my-1 mr-5"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm6>
                <v-flex d-flex>
                  <v-card flat>
                    <v-card-title primary class="title hidden-xs-only"
                      >&nbsp;</v-card-title
                    >
                    <v-card-text>
                      <v-text-field
                        v-model="address1"
                        prepend-icon="home"
                        name="address1"
                        label="Address of Team"
                        type="text"
                        class="my-1 mr-5"
                      ></v-text-field>
                      <v-text-field
                        v-model="address2"
                        prepend-icon="blank"
                        name="address2"
                        label="Address line 2"
                        type="text"
                        class="my-1 mr-5"
                      ></v-text-field>
                      <v-text-field
                        v-model="town"
                        prepend-icon="blank"
                        name="town"
                        label="Town"
                        type="text"
                        class="my-1 mr-5"
                      ></v-text-field>
                      <v-text-field
                        v-model="county"
                        prepend-icon="blank"
                        name="county"
                        label="County"
                        type="text"
                        class="my-1 mr-5"
                      ></v-text-field>
                      <v-text-field
                        v-model="postcode"
                        prepend-icon="blank"
                        name="postcode"
                        label="Postcode"
                        type="text"
                        class="my-1 mr-5"
                      ></v-text-field>
                      <v-autocomplete
                        v-model="country"
                        :items="countryList()"
                        prepend-icon="blank"
                        name="country"
                        label="Country"
                        browser-autocomplete="off"
                        class="mr-5"
                      >
                      </v-autocomplete>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-flex>
              <v-flex d-flex xs12>
                <v-card color="grey lighten-5" flat class="rounded-card">
                  <v-alert
                    v-if="error"
                    :value="true"
                    type="error"
                    icon="warning"
                    class="mb-4"
                  >
                    {{ errorMessage }}
                  </v-alert>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      round
                      outline
                      color="primary"
                      :disabled="!isDirty"
                      @click="resetForm"
                    >
                      <span class="">Reset</span>
                    </v-btn>
                    <v-btn
                      :disabled="!valid || !isDirty"
                      type="submit"
                      round
                      color="accent"
                      :loading="loading"
                      form="teamForm"
                      @click="validate"
                    >
                      <v-icon small left>save</v-icon>
                      <span class="">Save Changes</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
// import moment from 'moment-timezone'
// when time comes look to https://github.com/prantlf/timezone-support

export default {
  data: () => ({
    nameError: null,
    websiteRules: [
      v => {
        if (v && v.length) {
          // eslint-disable-next-line
          const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
          return pattern.test(v) || 'Please enter a valid website address';
        }
        return true;
      }
    ],
    loading: false,
    valid: true,
    error: false,
    errorMessage: 'Error.',
    name: null,
    conflictName: null,
    description: null,
    url: null,
    phone: null,
    logo: null,
    address1: null,
    address2: null,
    town: null,
    county: null,
    postcode: null,
    country: null,
    originalName: null,
    originalDescription: null,
    originalUrl: null,
    originalPhone: null,
    originalLogo: null,
    originalAddress1: null,
    originalAddress2: null,
    originalTown: null,
    originalCounty: null,
    originalPostcode: null,
    originalCountry: null
  }),
  computed: {
    ...mapState('auth', ['team']),
    ...mapGetters('auth', ['isTeamOwner']),
    isDirty() {
      return (
        this.name !== this.originalName ||
        this.description !== this.originalDescription ||
        this.url !== this.originalUrl ||
        this.phone !== this.originalPhone ||
        this.logo !== this.originalLogo ||
        this.address1 !== this.originalAddress1 ||
        this.address2 !== this.originalAddress2 ||
        this.town !== this.originalTown ||
        this.county !== this.originalCounty ||
        this.postcode !== this.originalPostcode ||
        this.country !== this.originalCountry
      );
    }
  },
  watch: {
    name: function() {
      if (this.name !== this.conflictName) {
        this.nameError = null;
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log('beforeRouteEnter', to, from);
  //   if (!this.isTeamOwner) {
  //     next(false);
  //   } else {
  //     // team owners only in here please.
  //     next();
  //   }
  // },
  created: async function() {
    // console.log('created');
    const res = await this.$store.dispatch('auth/getTeam');
    if (res) {
      // console.log('res', res);
      this.name = res.name;
      this.originalName = res.name;
      this.description = res.description;
      this.originalDescription = res.description;
      this.url = res.url;
      this.originalUrl = res.url;
      this.phone = res.phone;
      this.originalPhone = res.phone;
      this.logo = res.logo;
      this.originalLogo = res.logo;
      this.address1 = res.address1;
      this.originalAddress1 = res.address1;
      this.address2 = res.address2;
      this.originalAddress2 = res.address2;
      this.town = res.town;
      this.originalTown = res.town;
      this.county = res.county;
      this.originalCounty = res.county;
      this.postcode = res.postcode;
      this.originalPostcode = res.postcode;
      this.country = res.country;
      this.originalCountry = res.country;
    } else {
      this.name = this.team.name;
      this.originalName = this.team.name;
      this.description = this.team.description;
      this.originalDescription = this.team.description;
      this.url = this.team.url;
      this.originalUrl = this.team.url;
      this.phone = this.team.phone;
      this.originalPhone = this.team.phone;
      this.logo = this.team.logo;
      this.originalLogo = this.team.logo;
      this.address1 = this.team.address1;
      this.originalAddress1 = this.team.address1;
      this.address2 = this.team.address2;
      this.originalAddress2 = this.team.address2;
      this.town = this.team.town;
      this.originalTown = this.team.town;
      this.county = this.team.county;
      this.originalCounty = this.team.county;
      this.postcode = this.team.postcode;
      this.originalPostcode = this.team.postcode;
      this.country = this.team.country;
      this.originalCountry = this.team.country;
    }
    // console.log('created awaited');
  },
  methods: {
    resetForm() {
      this.error = false;
      this.nameError = null;
      this.conflictName = null;
      this.errorMessage = 'Error.';
      this.name = this.originalName;
      this.url = this.originalUrl;
      this.phone = this.originalPhone;
      this.logo = this.originalLogo;
      this.address1 = this.originalAddress1;
      this.address2 = this.originalAddress2;
      this.town = this.originalTown;
      this.county = this.originalCounty;
      this.postcode = this.originalPostcode;
      this.country = this.originalCountry;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.error = false;
        this.nameError = null;
        this.conflictName = null;
        this.loading = true;
        const response = await this.updateTeam({
          teamId: this.team._id,
          name: this.name,
          description: this.description,
          url: this.url || '',
          phone: this.phone || '',
          logo: this.logo || '',
          address1: this.address1 || '',
          address2: this.address2 || '',
          town: this.town || '',
          county: this.county || '',
          postcode: this.postcode || '',
          country: this.country
        });
        this.loading = false;
        if (response && response.error) {
          // eslint-disable-next-line
          // console.log('updateTeam:', response);
          if (response.statusCode === 409) {
            this.conflictName = this.name;
            this.nameError =
              'This team name is already assigned to another Groupmail account. Please choose a different name.';
            // this.errorMessage = `Error! This team name is already assigned to another Groupmail account. Please choose a different name (code: ${
            //   response.statusCode
            // })`
          } else if (response.statusCode === 401) {
            this.errorMessage = `Error! Apparently your token has expired (code: ${response.statusCode})`;
            this.error = true;
          } else {
            this.errorMessage = `Error! ${response.message} (code ${response.statusCode})`;
            this.error = true;
          }
        } else {
          this.setSnack('You have successfully updated your team profile.');
          this.originalName = this.name;
          this.originalDescription = this.description;
          this.originalUrl = this.url;
          this.originalPhone = this.phone;
          this.originalLogo = this.logo;
          this.originalAddress1 = this.address1;
          this.originalAddress2 = this.address2;
          this.originalTown = this.town;
          this.originalCounty = this.county;
          this.originalPostcode = this.postcode;
          this.originalCountry = this.country;
        }
      }
    },
    countryList() {
      return [
        'Afghanistan',
        'Åland Islands',
        'Albania',
        'Algeria',
        'American Samoa',
        'Andorra',
        'Angola',
        'Anguilla',
        'Antarctica',
        'Antigua and Barbuda',
        'Argentina',
        'Armenia',
        'Aruba',
        'Australia',
        'Austria',
        'Azerbaijan',
        'Bahamas',
        'Bahrain',
        'Bangladesh',
        'Barbados',
        'Belarus',
        'Belgium',
        'Belize',
        'Benin',
        'Bermuda',
        'Bhutan',
        'Bolivia',
        'Bosnia and Herzegovina',
        'Botswana',
        'Bouvet Island',
        'Brazil',
        'British Indian Ocean Territory',
        'Brunei Darussalam',
        'Bulgaria',
        'Burkina Faso',
        'Burundi',
        'Cambodia',
        'Cameroon',
        'Canada',
        'Cape Verde',
        'Cayman Islands',
        'Central African Republic',
        'Chad',
        'Chile',
        'China',
        'Christmas Island',
        'Cocos (Keeling) Islands',
        'Colombia',
        'Comoros',
        'Congo',
        'Congo, The Democratic Republic of the',
        'Cook Islands',
        'Costa Rica',
        "Cote D'Ivoire",
        'Croatia',
        'Cuba',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'Djibouti',
        'Dominica',
        'Dominican Republic',
        'Ecuador',
        'Egypt',
        'El Salvador',
        'Equatorial Guinea',
        'Eritrea',
        'Estonia',
        'Ethiopia',
        'Falkland Islands (Malvinas)',
        'Faroe Islands',
        'Fiji',
        'Finland',
        'France',
        'French Guiana',
        'French Polynesia',
        'French Southern Territories',
        'Gabon',
        'Gambia',
        'Georgia',
        'Germany',
        'Ghana',
        'Gibraltar',
        'Greece',
        'Greenland',
        'Grenada',
        'Guadeloupe',
        'Guam',
        'Guatemala',
        'Guernsey',
        'Guinea',
        'Guinea-Bissau',
        'Guyana',
        'Haiti',
        'Heard Island and Mcdonald Islands',
        'Holy See (Vatican City State)',
        'Honduras',
        'Hong Kong',
        'Hungary',
        'Iceland',
        'India',
        'Indonesia',
        'Iran, Islamic Republic Of',
        'Iraq',
        'Ireland',
        'Isle of Man',
        'Israel',
        'Italy',
        'Jamaica',
        'Japan',
        'Jersey',
        'Jordan',
        'Kazakhstan',
        'Kenya',
        'Kiribati',
        "Korea, Democratic People's Republic of",
        'Korea, Republic of',
        'Kuwait',
        'Kyrgyzstan',
        "Lao People'S Democratic Republic",
        'Latvia',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libyan Arab Jamahiriya',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Macao',
        'Macedonia, The Former Yugoslav Republic of',
        'Madagascar',
        'Malawi',
        'Malaysia',
        'Maldives',
        'Mali',
        'Malta',
        'Marshall Islands',
        'Martinique',
        'Mauritania',
        'Mauritius',
        'Mayotte',
        'Mexico',
        'Micronesia, Federated States of',
        'Moldova, Republic of',
        'Monaco',
        'Mongolia',
        'Montserrat',
        'Morocco',
        'Mozambique',
        'Myanmar',
        'Namibia',
        'Nauru',
        'Nepal',
        'Netherlands',
        'Netherlands Antilles',
        'New Caledonia',
        'New Zealand',
        'Nicaragua',
        'Niger',
        'Nigeria',
        'Niue',
        'Norfolk Island',
        'Northern Mariana Islands',
        'Norway',
        'Oman',
        'Pakistan',
        'Palau',
        'Palestinian Territory, Occupied',
        'Panama',
        'Papua New Guinea',
        'Paraguay',
        'Peru',
        'Philippines',
        'Pitcairn',
        'Poland',
        'Portugal',
        'Puerto Rico',
        'Qatar',
        'Reunion',
        'Romania',
        'Russian Federation',
        'RWANDA',
        'Saint Helena',
        'Saint Kitts and Nevis',
        'Saint Lucia',
        'Saint Pierre and Miquelon',
        'Saint Vincent and the Grenadines',
        'Samoa',
        'San Marino',
        'Sao Tome and Principe',
        'Saudi Arabia',
        'Senegal',
        'Serbia and Montenegro',
        'Seychelles',
        'Sierra Leone',
        'Singapore',
        'Slovakia',
        'Slovenia',
        'Solomon Islands',
        'Somalia',
        'South Africa',
        'South Georgia and the South Sandwich Islands',
        'Spain',
        'Sri Lanka',
        'Sudan',
        'Suriname',
        'Svalbard and Jan Mayen',
        'Swaziland',
        'Sweden',
        'Switzerland',
        'Syrian Arab Republic',
        'Taiwan',
        'Tajikistan',
        'Tanzania, United Republic of',
        'Thailand',
        'Timor-Leste',
        'Togo',
        'Tokelau',
        'Tonga',
        'Trinidad and Tobago',
        'Tunisia',
        'Turkey',
        'Turkmenistan',
        'Turks and Caicos Islands',
        'Tuvalu',
        'Uganda',
        'Ukraine',
        'United Arab Emirates',
        'United Kingdom',
        'United States',
        'United States Minor Outlying Islands',
        'Uruguay',
        'Uzbekistan',
        'Vanuatu',
        'Venezuela',
        'Viet Nam',
        'Virgin Islands, British',
        'Virgin Islands, U.S.',
        'Wallis and Futuna',
        'Western Sahara',
        'Yemen',
        'Zambia',
        'Zimbabwe'
      ];
    },
    ...mapActions({
      updateTeam: 'account/updateTeam',
      // refreshToken: 'auth/fetch',
      setSnack: 'snackbar/setSnack'
    })
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isDirty && this.user) {
      const res = await this.$dialog.warning({
        text:
          'You have un-saved changes. Do you really want to exit without saving first?',
        title: 'Discard Un-saved changes?',
        actions: {
          false: {
            text: 'No',
            color: 'primary'
          },
          true: {
            text: 'Yes',
            color: 'red'
          }
        }
      });
      if (res) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
